export enum ApplicationType {
  HWRC = "HWRC",
  MyAccess ="MyAccess",
  Whitespace ="Whitespace"
}
